export const formatCards = (cards, row) => {
  return cards.map((card) => {
    const updatedCard = { ...card };
    updatedCard.flipped = false;
    updatedCard.row = row;
    return updatedCard;
  });
};
